<p-toast></p-toast>
<p-card>
    <div style="text-align: center;">
        <p-progressSpinner *ngIf="loading" [style]="{width: '200px', height: '200px'}"></p-progressSpinner>
    </div>
    <div class="card" *ngIf="!loading">
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="empresa" style="font-family: system-ui;">Empresa</label>
                <p-dropdown class="p-inputtext-sm" [options]="empresas" [(ngModel)]="selecionarEmpresa"
                    [showClear]="true" optionLabel="nome_fantasia" placeholder="Selecione a Empresa"></p-dropdown>
            </div>
        </div>
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-12 p-lg-12">
                <label for="selecionarOrigem" style="font-family: system-ui;">Origem</label>
                <p-dropdown class="p-inputtext-sm" [options]="origens" [(ngModel)]="selecionarOrigem"
                    optionLabel="nome"></p-dropdown>
            </div>
        </div>
        <div class="p-grid p-fluid">
            <div class="p-col-12 p-md-6 p-lg-4">
                <label for="selecionarPeriodo" style="font-family: system-ui;">Período</label>
                <p-dropdown class="p-inputtext-sm" [options]="periodos" [(ngModel)]="selecionarPeriodo"
                    optionLabel="nome" optionValue="nome" (onChange)="onChangePeriodo($event)"></p-dropdown>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Inicial</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>

            <div class="p-col-12 p-md-6 p-lg-3">
                <label style="font-family: system-ui;">Data Final</label>
                <p-calendar class="p-inputtext-sm" [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true"
                    inputId="icon" showButtonBar="true">
                </p-calendar>
            </div>
            <div class="p-col-12 p-md-6 p-lg-2" style="align-self: flex-end;">
                <button style="height: 39.272px; background-color: rgb(167, 32, 8);" pButton pRipple type="button" label="Pesquisar"
                    class="p-button-raised" (click)="pesquisar()"></button>
            </div>

        </div>
        <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-7">
                <p-table #dt [value]="lista" selectionMode="single" [(selection)]="selectedList"
                    styleClass="p-datatable-sm p-datatable-striped" dataKey="origem" [scrollable]="true"
                    scrollHeight="300px" (onRowSelect)="onRowSelect($event)">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 300px;">Origem</th>
                            <th style="width: 90px; text-align: right;">Valor</th>
                            <th style="width: 90px;text-align: right;">%</th>
                            <th style="width: 90px;text-align: right;">Parcelas</th>
                            <th style="width: 90px;text-align: right;">%</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-cliente>
                        <tr [pSelectableRow]="cliente">
                            <td style="width: 300px;"><b>{{cliente.origem}}</b></td>
                            <td style="width: 90px;text-align: right;">{{cliente.valor}}</td>
                            <td style="width: 90px;text-align: right;">{{cliente.perc_valor}}</td>
                            <td style="width: 90px;text-align: right;">{{cliente.parcelas}}</td>
                            <td style="width: 90px;text-align: right;">{{cliente.perc_parcelas}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <div class="p-col-12 p-md-6 p-lg-5">
                <p-chart type="pie" [data]="grafico"></p-chart>
            </div>
        </div>

        <!-- <div class="p-grid nested-grid">
            <div class="p-col-12 p-md-6 p-lg-12">
                <p-chart type="polarArea" [data]="grafico_bar"></p-chart>
            </div>
        </div> -->
    </div>
</p-card>

<!-- RENDIMENTOS -->
<!-- <p-dialog header="Rendimentos" [(visible)]="displayRendimentos" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaRendimentos" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 180px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 180px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 180px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 180px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalRendimentos}}</b></span>
            <p-button icon="pi pi-check" (click)="displayRendimentos=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog> -->
<!-- FIM RENDIMENTOS -->

<!-- Títulos Vencidos -->
<p-dialog header="Títulos Vencidos" [(visible)]="displayTitulosVencidos" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaTitulosVencidos" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 180px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 180px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 180px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 180px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalTitulosVencidos}}</b></span>
            <p-button icon="pi pi-check" (click)="displayTitulosVencidos=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM Títulos Vencidos -->

<!-- C - Títulos a Vencer -->
<p-dialog header="Títulos a Vencer" [(visible)]="displayTitulosVencer" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaTitulosVencer" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalTitulosVencer}}</b></span>
            <p-button icon="pi pi-check" (click)="displayTitulosVencer=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM C - Títulos a Vencer -->

<!-- D - PG(TRANFERENCIA PAGO DENTRO DO MES) -->
<p-dialog header="TRANFERENCIA PAGO DENTRO DO MES" [(visible)]="displayRecebidosPG" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaRecebidosPG" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Data Pagamento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.data_pagamento | date: 'dd/MM/yyyy'}}</td>
           </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalRecebidosPG}}</b></span>
            <p-button icon="pi pi-check" (click)="displayRecebidosPG=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM D - PG(TRANFERENCIA PAGO DENTRO DO MES) -->

<!-- E - RECEBIDO ATÉ DO VENCIMENTO(sim SÓ BOLETO) -->
<p-dialog header="RECEBIDO ATÉ DO VENCIMENTO(sim SÓ BOLETO)" [(visible)]="displayRecebidosAteVencimentoBoleto" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaRecebidosAteVencimentoBoleto" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Data Pagamento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.data_pagamento | date: 'dd/MM/yyyy'}}</td>
            </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalRecebidosAteVencimentoBoleto}}</b></span>
            <p-button icon="pi pi-check" (click)="displayRecebidosAteVencimentoBoleto=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM E - RECEBIDO ATÉ DO VENCIMENTO(sim SÓ BOLETO) -->

<!-- F - BX(INADIPLENCIA FORA DO MES EM FORMA DE TRANFERENCIA) -->
<p-dialog header="BX(INADIPLENCIA FORA DO MES EM FORMA DE TRANFERENCIA)" [(visible)]="displayRecebidosBX" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaRecebidosBX" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Data Pagamento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.data_pagamento | date: 'dd/MM/yyyy'}}</td>
           </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalRecebidosBX}}</b></span>
            <p-button icon="pi pi-check" (click)="displayRecebidosBX=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM F - BX(INADIPLENCIA FORA DO MES EM FORMA DE TRANFERENCIA) -->

<!-- G - INAD(INADIPLENCIA FORA DO MES EM FORMA DE BOLETO) -->
<p-dialog header="INAD(INADIPLENCIA FORA DO MES EM FORMA DE BOLETO)" [(visible)]="displayRecebidosInad" [modal]="true" [style]="{width: '90vw'}" [baseZIndex]="10000">

    <p-table #dt [value]="listaRecebidosInad" selectionMode="single" styleClass="p-datatable-sm p-datatable-striped"
        dataKey="origem" [scrollable]="true">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;font-size:12px;">NF</th>
                <th style="width: 90px; text-align: right;font-size:12px;">Valor</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Cliente</th>
                <th style="width: 150px;text-align: left;font-size:12px;">Endereço</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Vencimento</th>
                <th style="width: 90px;text-align: center;font-size:12px;">Data Pagamento</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-cliente>
            <tr [pSelectableRow]="cliente">
                <td style="width: 50px;font-size:12px;"><b>{{cliente.nf}}</b></td>
                <td style="width: 90px; text-align: right;font-size:12px;">{{cliente.valor_parcela | currency:'BRL':true}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.cliente}}</td>
                <td style="width: 150px;text-align: left;font-size:12px;">{{cliente.endereco}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.vencimento | date: 'dd/MM/yyyy'}}</td>
                <td style="width: 90px;text-align: center;font-size:12px;">{{cliente.data_pagamento | date: 'dd/MM/yyyy'}}</td>
           </tr>
        </ng-template>
    </p-table>
    <div>

    </div>
    <ng-template pTemplate="footer">
        <div>
            <span style="
            background-color: cornflowerblue;
            padding: 5px;
            border-radius: 10px;
            float: left;
        "><b>TOTAL : {{totalRecebidosInad}}</b></span>
            <p-button icon="pi pi-check" (click)="displayRecebidosInad=false" label="FECHAR" styleClass="p-button-text">
            </p-button>
        </div>

    </ng-template>
</p-dialog>
<!-- FIM G - INAD(INADIPLENCIA FORA DO MES EM FORMA DE BOLETO) -->